import React from 'react'
import { useTranslation } from 'react-i18next'
import HeaderAbout from './Sections/HeaderAbout'
import SectionAbout from './Sections/SectionAbout'
import SubMenuNav from '../Menu/SubMenu/SubMenuNav '
import { Header } from '../common/Header/Header'

import Footer from '../Home/Footer';

const About = () => {
    const { t } = useTranslation();
    return (
        <>
            <main className=''>
                <div className='bg-white '>
                    <Header></Header>
                </div>
                <div className='sticky-top'>
                    <SubMenuNav />
                </div>
                <div className='border-bottom border-1 border-light-subtle  mb-4'>
                    <div className='container py-lg-5 py-2'>
                        <h2 className='text-secondary text-center'>{t('about.title')}</h2>
                    </div>
                </div>
                <div className='container'>
                    <HeaderAbout />
                    <SectionAbout />

                </div>



                <Footer />
            </main>
        </>
    )
}

export default About